import Choices from 'choices.js';

export default class extends Controller {
  static targets = ['select'];

  initialize() {
    new Choices(this.selectTarget, { itemSelectText: '', searchResultLimit: 10 });
    this.selectTarget.addEventListener('change', this.changeHandler.bind(this));
  }

  changeHandler(event) {
    window.location = event.detail.value;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/company-select-controller.js